import * as api from '../../api';
import { isEnumMember } from 'common/dist/utils/types';

export function convertAddressToPlace(
  address: api.Address.Address,
): api.Places.PlaceDetails {
  return {
    addressOne: address.address || '',
    addressTwo: address.unitNumber || '',
    city: address.city || '',
    state: address.state || '',
    zipCode: address.zip || '',
    latitude: address.latitude || null,
    longitude: address.longitude || null,
  };
}

export function convertPlaceToAddress(
  place: api.Places.PlaceDetails,
): api.Address.Address {
  return {
    address: place.addressOne || null,
    unitNumber: place.addressTwo || null,
    city: place.city || null,
    state: isEnumMember(api.Address.State, place.state) ? place.state : null,
    zip: place.zipCode || null,
    latitude: place.latitude || null,
    longitude: place.longitude || null,
  };
}
